module.exports = __webpack_public_path__ + "img/ReviewDetails_0.8e7fb3c9.png";